import { EventInterceptionPlugin, FlagOverridePlugin } from '@launchdarkly/toolbar';

export const flagOverridePlugin = new FlagOverridePlugin({ storageNamespace: 'ld-flag-override' });
export const eventInterceptionPlugin = new EventInterceptionPlugin({
    enableLogging: true,
});
